"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdatePortalSettingsRequestStatus = exports.getFetchPortalSettingsRequestStatus = exports.getStagedPortalSettingsCount = exports.getStagedPortalSettingsChanges = exports.getStagedChangesCount = exports.getStagedChanges = exports.getCreatedProductFolders = exports.getGDPRUnsubscribeLinkEnabled = exports.getGDPREnforcementEnabled = exports.getGDPRComplianceEnabled = exports.getLeadRevisitNotificationsEnabled = exports.getTrackingAnonymizationEnabled = exports.getPortalSettingsResponse = exports.getPortalSettings = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _actions = require("../PortalSettings/actions");

var _PortalSettingsKeys = _interopRequireWildcard(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var getPortalSettingsState = function getPortalSettingsState(state) {
  return state.portalSettings;
};

var getPortalSettings = (0, _reselect.createSelector)([getPortalSettingsState], function (state) {
  return state.get('data').merge(state.get('staged'));
});
exports.getPortalSettings = getPortalSettings;
var getPortalSettingsResponse = (0, _reselect.createSelector)(getPortalSettingsState, function (portalSettings) {
  return portalSettings.has('response') ? portalSettings.get('response').toJS() : [];
});
exports.getPortalSettingsResponse = getPortalSettingsResponse;
var getTrackingAnonymizationEnabled = (0, _reselect.createSelector)(getPortalSettings, function (state) {
  return (state.get(_PortalSettingsKeys.default.EMAIL_SERVICES_OPEN_TRACKING_ANONYMIZATION_ENABLED) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.EMAIL_SERVICES_OPEN_TRACKING_ANONYMIZATION_ENABLED]) == 'true';
});
exports.getTrackingAnonymizationEnabled = getTrackingAnonymizationEnabled;
var getLeadRevisitNotificationsEnabled = (0, _reselect.createSelector)([getPortalSettings], function (state) {
  return (state.get(_PortalSettingsKeys.default.LEAD_REVISIT_NOTIFICATIONS_ENABLED) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.LEAD_REVISIT_NOTIFICATIONS_ENABLED]) == 'true';
});
exports.getLeadRevisitNotificationsEnabled = getLeadRevisitNotificationsEnabled;
var getGDPRComplianceEnabled = (0, _reselect.createSelector)([getPortalSettings], function (state) {
  return (state.get(_PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED]) == 'true';
});
exports.getGDPRComplianceEnabled = getGDPRComplianceEnabled;
var getGDPREnforcementEnabled = (0, _reselect.createSelector)([getPortalSettings], function (state) {
  return (state.get(_PortalSettingsKeys.default.GDPR_ENFORCEMENT_ENABLED) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.GDPR_ENFORCEMENT_ENABLED]) == 'true';
});
exports.getGDPREnforcementEnabled = getGDPREnforcementEnabled;
var getGDPRUnsubscribeLinkEnabled = (0, _reselect.createSelector)([getPortalSettings], function (state) {
  return (state.get(_PortalSettingsKeys.default.GDPR_UNSUBSCRIBE_LINK_ENABLED) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.GDPR_UNSUBSCRIBE_LINK_ENABLED]) == 'true';
});
exports.getGDPRUnsubscribeLinkEnabled = getGDPRUnsubscribeLinkEnabled;
var getCreatedProductFolders = (0, _reselect.createSelector)([getPortalSettings], function (state) {
  return (state.get(_PortalSettingsKeys.default.CREATED_PRODUCT_FOLDERS) || _PortalSettingsKeys.DEFAULTS[_PortalSettingsKeys.default.CREATED_PRODUCT_FOLDERS]) == 'true';
});
exports.getCreatedProductFolders = getCreatedProductFolders;
var getStagedChanges = (0, _reselect.createSelector)([getPortalSettingsState], function (state) {
  return state.get('staged').reduce(function (acc, val, key) {
    if (state.getIn(['data', key]) !== val) {
      return acc.set(key, val);
    }

    return acc;
  }, (0, _immutable.Map)());
});
exports.getStagedChanges = getStagedChanges;
var getStagedChangesCount = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.size;
});
exports.getStagedChangesCount = getStagedChangesCount;
var getStagedPortalSettingsChanges = (0, _reselect.createSelector)([getPortalSettingsState], function (portalSettingsState) {
  return portalSettingsState.get('staged').reduce(function (acc, val, key) {
    if (portalSettingsState.getIn(['data', key]) !== val) {
      return (0, _extends3.default)((0, _defineProperty2.default)({}, key, val), acc);
    }

    return acc;
  }, {});
});
exports.getStagedPortalSettingsChanges = getStagedPortalSettingsChanges;
var getStagedPortalSettingsCount = (0, _reselect.createSelector)([getStagedPortalSettingsChanges], function (stagedPortalSettingsChanges) {
  return Object.keys(stagedPortalSettingsChanges).length;
});
exports.getStagedPortalSettingsCount = getStagedPortalSettingsCount;
var getFetchPortalSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS);
exports.getFetchPortalSettingsRequestStatus = getFetchPortalSettingsRequestStatus;
var getUpdatePortalSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.PortalSettingsActionTypes.UPDATE_PORTAL_SETTINGS);
exports.getUpdatePortalSettingsRequestStatus = getUpdatePortalSettingsRequestStatus;